import restApi from "../../http.js";
import env from "../../env.js";
import session from "../session.js";

export default class Api {
  validateEmails(request) {
    return restApi({
      method: "POST",
      url: "/bouncer/validate-emails",
      data: request,
    });
  }

  getInstaFeed() {
    return restApi({
      method: "get",
      url: "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + env.instagramToken(),
    });
  }

  // getCountries() {
  //   return restApi({
  //     method: "GET",
  //     url: "/countries/available",
  //     headers: {
  //       Authorization: "Bearer " + session.getAccessToken(),
  //     },
  //   });
  // }

  getAllCountries() {
    return restApi({
      method: "GET",
      url: "/countries",
    });
  }

  getCountries() {
    return restApi({
      method: "GET",
      url: "/countries",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getStates(request) {
    return restApi({
      method: "GET",
      url: "/countries/" + request.id + "/states",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getNumberOfFollowers(request) {
    return restApi({
      method: "GET",
      url: "https://www.instagram.com/" + request.username + "/?__a=1",
    });
  }

  getReferrerByCode(param) {
    return restApi({
      method: "GET",
      url: "/brands/brand-referral",
      params: {
        referralCode: param,
      },
    });
  }

  getReferrerById(param) {
    return restApi({
      method: "GET",
      url: "/brands/brand-referral",
      params: {
        referralId: param,
      },
    });
  }

  getMeRetailer() {
    return restApi({
      method: "GET",
      url: "/retailers/me",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  updateRetailer(request) {
    return restApi({
      method: "PATCH",
      url: "/retailers/me/account ",
      data: request,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  uploadRetailerThumb(image) {
    return restApi({
      method: "POST",
      url: `/retailers/thumbnail-image`,
      data: image,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  updatePassword(request) {
    return restApi({
      method: "POST",
      url: "/auth/change-password",
      data: request,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getAllRetailers() {
    return restApi({
      method: "GET",
      url: "/retailers/dropdown",
    });
  }

  getBrandRetailers(id) {
    return restApi({
      method: "GET",
      url: `/brands/${id}/retailers`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getAllBrands(param) {
    return restApi({
      method: "GET",
      url: "/brands/dropdown",
      params: {
        is_published: param,
      },
    });
  }

  getMinimumOrderValues() {
    return restApi({
      method: "GET",
      url: "/orders/minimum-order-values",
    });
  }

  async getLocations() {
    try {
      const { data } = await restApi({
        method: "GET",
        url: "/countries/states",
      });
      return (data?.countries || [])
        .map(({code, name, state}) => {
          return {code, name, states: state };
        })
        .sort((country1) => {
          return country1.code === "USA" ? 1 : -1;
        });
    } catch (e) {
      return [];
    }
  }
}
